import * as React from 'react';
import { useNavigate, useOutletContext } from 'react-router-dom';

import { 
  Button, 
  Box, 
  Typography, 
  Container,
  CircularProgress,
  TextField
} from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';


import { TokenValidator, SimpleValidators, CONST } from '../../utils';
import { Sessions } from '../../controllers';

export default function Login() {
    const nav = useNavigate();
    const {Login:Context} = useOutletContext();

    const [fetching, setFetch] = React.useState(false);
    const [loging, setLog] = React.useState(false);
    const [info, setInfo] = React.useState({user: '', pass: ''});

    React.useEffect(() => {
        handleLoad();        
    }, []);

    const handleLoad = async() => {

        setFetch(true);

        const token = await TokenValidator.GetInternalUser();

        if(token === null){
            setFetch(false);
            return;
        }

        const valid = await TokenValidator.ValidTokenDate(token);

        if(!valid){
            localStorage.removeItem(CONST.STORAGE_KEYS.INTERNAL_LOGIN);
            setFetch(false);
            return;
        }

        setFetch(false);
        setLog(true);

        Context.didLogin(true);

        nav('main', {replace: true});
    }

    const handleInput = async(e) => {
        setInfo({...info, [e.target.name]: e.target.value})
    };

    const handleSubmit = async(e) => {
        
        e.preventDefault();

        const isMail = await SimpleValidators.Email(info.user);
        
        if(!isMail){
            alert('No Valid E-Mail. Please, check inputs');
            return;
        }

        setFetch(true);

        const response = await Sessions.Internal(info.user, info.pass);

        setFetch(false);
        
        if(!response.success){
            alert(response.message);
            return;
        }

        setLog(true);
        Context.didLogin(true);
        await localStorage.setItem(CONST.STORAGE_KEYS.INTERNAL_LOGIN, JSON.stringify(response.token));
        nav('main', {replace: true});
    }

    return(
        <Container
            sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
            }}
        >
            <Box
                component='form'
                sx={{
                marginTop: 8,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                width: '50%'
                }}
                onSubmit={handleSubmit}
            >
                <Typography component="h1" variant="h5">
                Production Manegement - Sign in
                </Typography>

                <TextField
                    margin="normal"
                    required
                    fullWidth
                    label="Email Address"
                    id="user"
                    name="user"
                    autoComplete="user"
                    autoFocus
                    value={info.user}
                    onChange={handleInput}
                />

                <TextField
                    margin="normal"
                    required
                    fullWidth
                    label="Password"
                    type="password"
                    name="pass"
                    id="pass"
                    autoComplete="current-password"
                    value={info.pass}
                    onChange={handleInput}
                />

                <Button
                    type='submit'
                    fullWidth
                    variant="contained"
                    sx={{ mt: 3, mb: 2 }}
                    disabled={fetching && loging}
                >
                    Sign In
                </Button>
            </Box>

            {fetching && (
                <Box sx={{ 
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                }}>
                    <Typography component="h1"  variant="h5">
                    Login...
                    </Typography>
                    <br/>
                    <CircularProgress 
                    color='primary'
                    />
                </Box>
            )}

            {loging  && (
                <Box 
                    sx={{ 
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                    }}
                >
                    <CheckIcon color='primary'/>
                    <p>
                        Login successfull, redirecting...
                    </p>
                </Box>
            )}
        </Container>
    );
}